// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LoyaltySoftGatePopup-module-container-4x9fG{display:flex;flex-direction:column;justify-content:center;align-items:center;padding:40px;gap:20px}.LoyaltySoftGatePopup-module-btns-IQQbt{display:flex;gap:20px;padding-block-start:20px}.LoyaltySoftGatePopup-module-logoWrapper-3mGJz img{width:100px}", ""]);
// Exports
exports.locals = {
	"container": "LoyaltySoftGatePopup-module-container-4x9fG",
	"btns": "LoyaltySoftGatePopup-module-btns-IQQbt",
	"logoWrapper": "LoyaltySoftGatePopup-module-logoWrapper-3mGJz"
};
module.exports = exports;
